const $inject = ['moment'];

const guestTravellerService = function (moment) {
  const service = {};
  service.activeGuest = new Guest();

  service.addLoyaltyProgram = (programs) => {
    return programs.concat([new LoyaltyProgram()]);
  };

  service.removeLoyaltyProgram = (programs) => {
    return programs.slice(0, -1);
  };

  service.clear = () => {
    service.activeGuest = new Guest();
  };

  service.setActiveGuest = (traveller) => {
    let loyaltyPrograms = _.map(traveller.PersonalMemberships, (program) => {
      return {
        number: program.MembershipNumber,
        supplier: {
          Value: program.CompanyCode,
          Title: program.CompanyName,
          Type: program.MembershipTypeCode
        }
      };
    });

    if(loyaltyPrograms.length === 0) {
      loyaltyPrograms = loyaltyPrograms.concat([new LoyaltyProgram()]);
    }

    service.activeGuest = _.extend(new Guest(), {
      title: traveller.Salutation,
      firstName: traveller.Firstname,
      lastName: traveller.Lastname,
      email: traveller.Email,
      phone: traveller.Mobile,
      dob_day: traveller.DateOfBirth ? moment(traveller.DateOfBirth, 'YYYY-MM-DD[T]HH:mm:ss').format('D') : null,
      dob_month: traveller.DateOfBirth ? moment(traveller.DateOfBirth, 'YYYY-MM-DD[T]HH:mm:ss').format('MMMM') : null,
      dob_year: traveller.DateOfBirth ? moment(traveller.DateOfBirth, 'YYYY-MM-DD[T]HH:mm:ss').format('YYYY') : null,
      gender: traveller.Gender,
      guestID: traveller.guestID,
      costCentre: {
        Code: traveller.CostCentreCode,
        Title: traveller.CostCentreName
      },
      department: {
        Code: traveller.DepartmentCode,
        Title: traveller.DepartmentName
      },
      loyaltyPrograms: loyaltyPrograms,
      postcode: traveller.Postcode
    });
  };

  function Guest() {
    return {
      title: null,
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      dob_day: null,
      dob_month: null,
      dob_year: null,
      gender: null,
      loyaltyPrograms: [
        new LoyaltyProgram()
      ],
      costCentre: null,
      department: null,
      postcode: null
    };
  }

  function LoyaltyProgram() {
    return {
      supplier: null,
      number: null
    };
  }

  return service
};

guestTravellerService.$inject = $inject;

export default guestTravellerService;



// WEBPACK FOOTER //
// ./src/services/guestTravellerService.js